
import { Dropdown } from 'bootstrap';
const b2bDropdownEllipses = {
  props: {
    nocustomized: Boolean,
  },

  data() {
    return {
      dropdown: null,
      hover: false,
    }
  },
  mounted() {
    const { el } = this.$refs;
    this.dropdown = new Dropdown(el, {
      autoClose: true,
    });
  },

  template: `
<div class="dropdown card-dropdown pt-3" v-if="!nocustomized">
  <a href="#" ref="el" class="p-3 rounded dropdown-ellipses dropdown-toggle" @mouseover="hover = true"
    @mouseleave="hover = false"
    :style="hover ? 'background-color: rgb(0, 0, 0, 0.3)' : 'background-color:rgba(0, 0, 0, 0.1);'"
    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    <i class="text-white fe fe-more-vertical"></i>
  </a>
  <div class="dropdown-menu dropdown-menu-end">
    <slot></slot>
  </div>
</div>

<div class="dropdown" v-else>
  <a href="#" ref="el" class="dropdown-ellipses dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true"
    aria-expanded="false">
    <i class="fe fe-more-vertical"></i>
  </a>
  <div class="dropdown-menu dropdown-menu-end">
    <slot></slot>
  </div>
</div>
`
};
export default b2bDropdownEllipses;